import { t } from 'i18next';
import { LinearGradient } from 'expo-linear-gradient';
import { ScrollView, styled, SxProp, View, Image } from 'dripsy';
import { useState } from 'react';

import { UserEarnOfferListResponse } from '../../../../../../packages/utx-client/src/client';
import { EarnTabRoutes } from '../../earn.navigator';
import { OffersByCategory } from '../../hooks/useOffers.hook';
import { useEarnPageNavigator } from '../../utils/useEarnPageNavigator';
import { Icon } from '@/design-system/components/icons/Icon';
import { H3, H6 } from '@/design-system/components/typography';
import { AllOffersWeb } from '../../components/discover/AllOffersWeb';
import { PopularOffers } from '../../components/discover/PopularOffers';
import { PageContainer } from '../../components/page/PageContainer';
import { PageItem } from '../../components/page/PageItem';
import { PageHeader } from '../../components/page/PageHeader';

export interface DiscoverHomeProps {
  loading: boolean;
  offersLoading: boolean;
  popularOffersLoading: boolean;
  isNewAccount: boolean;
  offers: UserEarnOfferListResponse['data'];
  offersByCategory: OffersByCategory;
  popularOffers: UserEarnOfferListResponse['data'];
  refresh: () => void;
  openAccount: () => void;
  onSearch: (value?: string) => void;
  showAssets: {
    showMyAssetsOnly: boolean;
    toggleShowMyAssetsOnly: () => void;
  };
  showAssetsPoular: {
    showMyAssetsOnly: boolean;
    toggleShowMyAssetsOnly: () => void;
  };
}

export const DiscoverHome: React.FC<DiscoverHomeProps> = ({
  loading,
  offersLoading,
  popularOffersLoading,
  offers,
  offersByCategory,
  popularOffers,
  onSearch,
  showAssets,
  showAssetsPoular
}) => {
  const { data } = useEarnPageNavigator();

  const [bannerLayout, setBannerLayout] = useState({
    width: 0,
    height: 0
  });

  return (
    <ScrollView sx={styles.container} nestedScrollEnabled>
      <PageContainer noBackgroundImage sx={{ padding: '$10', paddingX: '$10' }}>
        <PageHeader data={data} currentPage={EarnTabRoutes.Discover} title={t('earn-invest::glossary.earn-and-invest')} />
        {/* <Banner /> */}
        <View
          sx={{ width: '100%', height: 300, marginBottom: '$5', borderRadius: 15, overflow: 'hidden', padding: 0 }}
          onLayout={(e) => {
            setBannerLayout({
              width: e.nativeEvent.layout.width,
              height: e.nativeEvent.layout.height
            });
          }}>
          {/* Background image */}
          <Image
            source={require('../../../../assets/images/earn_banner_bg.png')}
            sx={{ position: 'absolute', top: 0, left: 0, width: bannerLayout.width, height: bannerLayout.height }}
          />
          <View sx={{ position: 'absolute', bottom: 0, right: 0, height: '100%', paddingX: 120, justifyContent: 'flex-end', zIndex: 1 }}>
            <Icon name="landingPageWeb" height={261} width={469} />
          </View>
          <View
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              paddingX: '$8',
              gap: '$1',
              width: '100%',
              maxWidth: 756,
              height: '100%',
              justifyContent: 'center',
              alignItems: 'flex-start',
              zIndex: 2
            }}>
            <H3 bold sx={{ color: '$textTheme' }}>
              {t('earn-invest::glossary.earn-and-invest')}
            </H3>
            <H6 bold sx={{ color: '$textDarkBackground', textAlign: 'left' }}>
              {t('earn-invest::glossary.subscription-to-offers')}
            </H6>
          </View>
        </View>
        <PageItem sx={styles.pageItem}>
          <PopularOffers loading={popularOffersLoading} offers={popularOffers} showAssets={showAssetsPoular} onSearch={() => {}} />
        </PageItem>
        <View sx={{ height: '$5' }} />
        <PageItem sx={styles.pageItem}>
          <AllOffersWeb
            loading={offersLoading}
            offers={offers}
            offersByCategory={offersByCategory}
            onSearch={onSearch}
            showAssets={showAssets}
          />
        </PageItem>
      </PageContainer>
    </ScrollView>
  );
};

enum StyleName {
  container = 'container',
  discoverBanner = 'discoverBanner',
  discoverBannerImage = 'discoverBannerImage',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  discoverBanner: {
    paddingTop: '$10',
    paddingRight: '$10',
    paddingLeft: '$10',
    backgroundColor: 'transparent'
  },
  discoverBannerImage: {
    position: 'absolute',
    right: '$10',
    bottom: 0,
    height: 220,
    width: 400,
    zIndex: -1
  },
  pageItem: { padding: '$7', backgroundColor: '$backgroundPrimary', borderRadius: 15 }
};
